import { Link } from "react-router-dom";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "What areas do you service?",
    a: "We currently serve Pine Hill and nearby South Jersey communities. If you're nearby and not sure, send us a note via the Contact page and we'll let you know.",
  },
  {
    q: "What soap do you use?",
    a: "Only 100% biodegradable, eco-friendly cleaning solutions that are safe for your kids, your pets, and the storm drain. Followed by a sanitizing high-pressure rinse and a light deodorizer.",
  },
  {
    q: "What if it rains on my service day?",
    a: "We clean rain or shine. Bin cleaning is actually easier in light rain. In severe weather we'll automatically reschedule and notify you by email; you'll never be charged for a missed service.",
  },
  {
    q: "Do I need to be home?",
    a: "Nope. Just leave your bins curbside or in their normal spot the day after your trash pickup. We handle the rest and put them back where we found them.",
  },
  {
    q: "When do you clean. Before or after pickup?",
    a: "Always after. We arrive the day after your local trash pickup so the bins are empty and ready to be cleaned, sanitized, and deodorized.",
  },
  {
    q: "Can I cancel anytime?",
    a: "Yes. There are no contracts. You can pause, switch, or cancel your plan from your account portal (launching in our next phase) or just email Isaac.",
  },
  {
    q: "How do I know the job was done?",
    a: "After every clean we send you an email with a photo of your sparkling bins and a digital receipt. Photo-proof is included with every plan, no upcharges.",
  },
  {
    q: "Do you clean commercial dumpsters?",
    a: "We focus on residential service today, but we do take on small commercial and HOA accounts case-by-case. Use the Contact page and we'll send a custom quote.",
  },
  {
    q: "What if I have more than 2 bins?",
    a: "No problem. Add as many bins as you need at signup. Monthly and Bi-Weekly include up to 2 bins, with each additional bin priced at $8/month. One-Time is priced per bin.",
  },
  {
    q: "How does billing work?",
    a: "Subscription plans are billed monthly via secure Stripe payments (launching in our next phase). One-Time service is paid per cleaning. You'll always get a receipt by email.",
  },
];

export default function Faq() {
  return (
    <div data-testid="page-faq" className="bg-white">
      <section className="relative bg-gradient-to-b from-brand-50 to-white">
        <div className="container-page relative pt-16 pb-20 md:pt-24 md:pb-24">
          <div className="max-w-3xl">
            <p className="overline mb-4">FAQ</p>
            <h1 className="font-heading h1-fluid font-extrabold text-ink text-balance">
              Questions, <span className="text-brand">answered.</span>
            </h1>
            <p className="mt-6 text-lg text-slate-600 max-w-2xl leading-relaxed">
              Everything you've ever wondered about trash bin cleaning. And a
              few things you probably haven't.
            </p>
          </div>
        </div>
      </section>

      <section className="section-padding bg-white" data-testid="faq-section">
        <div className="container-page max-w-3xl">
          <Accordion
            type="single"
            collapsible
            className="w-full"
            data-testid="faq-accordion"
          >
            {FAQS.map((item, i) => (
              <AccordionItem
                key={item.q}
                value={`item-${i}`}
                className="border-b border-slate-100"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left font-heading text-lg sm:text-xl font-bold text-ink hover:text-brand py-6 hover:no-underline [&[data-state=open]]:text-brand">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-base text-slate-600 leading-relaxed pb-6">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      <section className="bg-brand-50/40 py-16">
        <div className="container-page text-center">
          <p className="overline mb-3">Still wondering?</p>
          <h3 className="font-heading text-3xl sm:text-4xl font-extrabold text-ink mb-6">
            Send us a quick note ,{" "}
            <span className="text-brand">we reply fast.</span>
          </h3>
          <Link to="/contact" className="btn-primary" data-testid="faq-contact-cta">
            Contact Us
          </Link>
        </div>
      </section>
    </div>
  );
}
